import FouGrid from 'components/layout/fou-grid/'
import FouGroup from 'components/layout/fou-group/'
import FouModal from 'components/overlay/fou-modal/'
import FouContainer from 'components/tools/fou-container/'
import FouPicture from 'components/tools/fou-picture/'
import GraphicUploader from 'src/pages/promotions/components/graphics/uploader'
import PromoImageViewer from 'src/pages/promotions/components/graphics/promo-image-viewer'
import { mapGetters } from 'vuex'

export default {
  name: 'graphics',

  components: {
    ...FouGrid,
    FouGroup,
    FouModal,
    FouContainer,
    FouPicture,
    GraphicUploader,
    PromoImageViewer
  },

  data() {
    return {
      minWidth: process.env.MIN_IMAGE_WIDTH,
      minHeight: process.env.MIN_IMAGE_HEIGHT
    }
  },

  computed: {
    ...mapGetters('promotions', {
      imageData: ['image']
    })
  },
  methods: {
    hasImageURL () {
      if (this.imageData?.hasOwnProperty('imageResourceLocation') && this.imageData?.imageResourceLocation) {
        return this.imageData.imageResourceLocation
      }
      return ''
    }
  }
}